import AppForm from './components/AppForm';
import PersonCard from './components/PersonCard';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { useState } from 'react';
import './styles/App.css';

function App() {
  const [targetProcess, setTargetProcess] = useState('');
  const initialPerson = {
    photo: '',
    name: '',
    age: '',
    email: '',
    phone: '',
    title: '',
    position: '',
    skills: '',
  };

  const [person, setPerson] = useState(initialPerson);

  return (
    <Router basename="/">
      <div className="App">
        <Switch>
            <Route path={`/PersonalForm/${targetProcess}`} render={ props => (              
              <AppForm {...props} targetProcess={targetProcess} person={person} setPerson={setPerson}/>
            ) } />
            <Route path="/PersonalCard" render={ props => (
              <PersonCard {...props} setTargetProcess={setTargetProcess} setPerson={setPerson} initialPerson={initialPerson}/>
            ) } />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
